<div class="form-holder user-name" *ngIf="namesForm$ | async as namesForm">
    <serviceos-ng-local-loader
        [showLoader]="showLoader"
    ></serviceos-ng-local-loader>
    <div class="form-header">
        <span class="form-title">{{ namesForm.title }}</span>
        <span class="toggle-btn" (click)="toggleForm()">{{
            userNameFormExpand
                ? namesForm.cancel_button_title
                : namesForm.edit_button_title
        }}</span>
    </div>
    <div
        class="form-content"
        [ngClass]="{ expand: userNameFormExpand }"
        *ngIf="userName$ | async as userName"
    >
        <div *ngIf="userNameFormExpand">
            <serviceos-ng-alert
                class="error-alert"
                *ngIf="formErrorMessage"
                [type]="'error'"
            >
                {{ formErrorMessage }}
            </serviceos-ng-alert>
            <form
                [formGroup]="userNameForm"
                (ngSubmit)="formSubmit()"
                id="user-name-form"
            >
                <div class="row">
                    <div class="col-6">
                        <serviceos-ng-form-field>
                            <serviceos-ng-label>{{
                                namesForm.edit_form.first_name_input_label
                            }}</serviceos-ng-label>
                            <input
                                [serviceosNgInput]="firstName?.value"
                                [error]="
                                    firstName?.invalid &&
                                    (firstName?.dirty || firstName?.touched)
                                "
                                type="text"
                                id="firstName"
                                name="firstName"
                                formControlName="firstName"
                            />
                            <serviceos-ng-error-message>{{
                                namesForm.edit_form.first_name_input_error
                            }}</serviceos-ng-error-message>
                        </serviceos-ng-form-field>
                    </div>
                    <div class="col-6">
                        <serviceos-ng-form-field>
                            <serviceos-ng-label>{{
                                namesForm.edit_form.last_name_input_label
                            }}</serviceos-ng-label>
                            <input
                                [serviceosNgInput]="lastName?.value"
                                [error]="
                                    lastName?.invalid &&
                                    (lastName?.dirty || lastName?.touched)
                                "
                                type="text"
                                id="lastName"
                                name="lastName"
                                formControlName="lastName"
                            />
                            <serviceos-ng-error-message>{{
                                namesForm.edit_form.last_name_input_error
                            }}</serviceos-ng-error-message>
                        </serviceos-ng-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <button type="submit">
                            {{ namesForm.edit_form.confirm_button_title }}
                        </button>
                    </div>
                </div>
            </form>
        </div>
        <div class="form-preview-holder" *ngIf="!userNameFormExpand">
            <span>{{ userName?.first_name }}</span>
            <span>{{ userName?.last_name }}</span>
        </div>
    </div>
</div>
